query WfaLabelOptions {
	wfa_session_runs(limit: 1000, sort: { fields: run_time, order: Descending }) {
		custom_fields
	}
}
